import React from "react";
import { Award, ShieldCheck, LifeBuoy, MessageSquareHeart, Lock, Users } from "lucide-react";
import { Reveal, SectionLabel } from "./primitives";
import { trustTiles, images } from "../data/content";

const tileIcons = [Award, ShieldCheck, LifeBuoy, MessageSquareHeart, Lock, Users];

export const AboutSection = () => (
  <section id="about" aria-labelledby="about-heading" className="bg-brand-bg py-16 lg:py-24">
    <div className="mx-auto max-w-content px-4 lg:px-8">
      <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
        <Reveal>
          <div className="relative overflow-hidden rounded-[28px] border border-brand-border shadow-md">
            <img
              src={images.advisor}
              alt="A Freeman Jones adviser speaking supportively with a customer."
              width="1264"
              height="848"
              loading="lazy"
              className="h-[340px] w-full object-cover lg:h-[460px]"
            />
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <SectionLabel>About Freeman Jones</SectionLabel>
          <h2
            id="about-heading"
            className="mt-3 font-heading text-3xl font-bold tracking-tight text-brand-navy lg:text-4xl"
          >
            Experienced, supportive and here throughout your arrangement
          </h2>
          <div className="mt-5 space-y-4 text-lg leading-relaxed text-brand-body">
            <p>
              Freeman Jones is an established insolvency services business, helping people take
              back control of their finances.
            </p>
            <p>
              Our Licensed Insolvency Practitioners propose and supervise Individual Voluntary
              Arrangements, working with you throughout the lifetime of your arrangement.
            </p>
            <p>
              We understand that dealing with debt can feel difficult. Our aim is to communicate
              clearly, treat you fairly and provide practical support throughout your IVA.
            </p>
          </div>
        </Reveal>
      </div>

      {/* Scrollable information cards */}
      <Reveal className="mt-12">
        <div className="mb-3 flex items-center justify-between">
          <p className="text-sm font-semibold uppercase tracking-[0.14em] text-brand-teal">
            Why customers choose us
          </p>
          <p className="hidden text-sm text-brand-body sm:block" aria-hidden="true">
            Scroll for more →
          </p>
        </div>
        <ul
          className="-mx-4 flex snap-x snap-mandatory gap-4 overflow-x-auto px-4 pb-4"
          data-testid="about-cards-scroller"
          tabIndex={0}
          aria-label="Reasons customers choose Freeman Jones — scrollable"
        >
          {trustTiles.map((tile, i) => {
            const Icon = tileIcons[i % tileIcons.length];
            return (
              <li
                key={tile.label}
                className="w-[260px] flex-shrink-0 snap-start rounded-2xl border border-brand-border bg-white p-6"
                data-testid={`trust-tile-${i}`}
              >
                <span className="grid h-11 w-11 place-items-center rounded-xl bg-brand-teal/10 text-brand-teal">
                  <Icon className="h-6 w-6" aria-hidden="true" />
                </span>
                <p className="mt-4 font-heading text-xl font-bold text-brand-navy">
                  {tile.value}
                </p>
                <p className="text-sm font-semibold text-brand-navy">{tile.label}</p>
                <p className="mt-2 text-sm leading-relaxed text-brand-body">{tile.sub}</p>
              </li>
            );
          })}
        </ul>
      </Reveal>
    </div>
  </section>
);
